import { supabase } from '../../lib/supabase'

export interface TradeMatch {
  game_account_id: string
  display_name: string
  region_code: string | null
  cards_they_offer: number[]
  cards_they_need: number[]
  match_score: number
  last_active_at?: string | null
}
export interface TradeRequest {
  id: string
  direction: 'sent' | 'received'
  other_account_name: string
  status: string
  message: string | null
  created_at: string
}

export async function listTradeMatches(accountId: string): Promise<TradeMatch[]> {
  const { data, error } = await supabase.rpc('trade_match_list', {
    p_game_account_id: accountId,
    p_limit: 20,
  })
  if (error) throw error
  return (data ?? []) as TradeMatch[]
}
export async function listTradeRequests(accountId: string): Promise<TradeRequest[]> {
  const { data, error } = await supabase.rpc('trade_request_list', { p_game_account_id: accountId })
  if (error) throw error
  return (data ?? []) as TradeRequest[]
}
export async function createTradeRequest(senderId: string, recipientId: string) {
  const { data, error } = await supabase.rpc('trade_request_create', {
    p_sender_account_id: senderId,
    p_recipient_account_id: recipientId,
    p_message: 'I would like to trade complementary cards.',
  })
  if (error) throw error
  const tradeRequestId = data as string
  void supabase.functions
    .invoke('send-trade-notification', { body: { trade_request_id: tradeRequestId } })
    .catch(() => undefined)
  return tradeRequestId
}
export async function respondTradeRequest(id: string, status: 'accepted' | 'declined') {
  const { error } = await supabase.rpc('trade_request_respond', {
    p_trade_request_id: id,
    p_status: status,
  })
  if (error) throw error
}
export async function cancelTradeRequest(id: string) {
  const { error } = await supabase.rpc('trade_request_cancel', { p_trade_request_id: id })
  if (error) throw error
}
export async function revealTradeContact(id: string) {
  const { data, error } = await supabase.rpc('trade_contact_reveal', { p_trade_request_id: id })
  if (error) throw error
  return data?.[0] as
    { account_name: string; contact_method: string; contact_value: string } | undefined
}
export async function createUserReport(
  reporterAccountId: string,
  reportedAccountId: string,
  reason: string,
  details: string,
) {
  const { error } = await supabase.rpc('user_report_create', {
    p_reporter_account_id: reporterAccountId,
    p_reported_account_id: reportedAccountId,
    p_reason: reason,
    p_details: details || null,
    p_trade_request_id: null,
  })
  if (error) throw error
}
